import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {SipProvider} from '../../../providers/sip/sip';
import {PatientDataProvider} from '../../../providers/patient-data/patient-data';
import {ViewController} from '../../../providers/view-controller.service';
import {ModalService} from '../../../providers/modal.service';
import {CallViewPageComponent} from '../../modals/call-view/call-view';
import {ChatPageComponent} from '../../modals/chat/chat';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-page-contacts',
  templateUrl: 'contacts.html',
  styleUrls: ['./contacts.scss']
})
export class ContactsPageComponent implements OnInit, OnDestroy {
  @Input() showHeader = true;

  isVideo = false;
  contacts: Array<any> = [];
  private callName = '';
  private onUpdateUI: Subscription;

  constructor(private viewCtrl: ViewController, private sipProvider: SipProvider,
              private modalCtrl: ModalService, private patientDataProvider: PatientDataProvider) {    
  }

  async ngOnInit() {
    this.contacts = await this.patientDataProvider.getContacts();
    this.onUpdateUI = this.sipProvider.events.subscribe('onUpdateUI', (session: any) => {
      if (session) {
        if (session.isInProgress() && session.connection) {
          this.dismiss();
          this.modalCtrl.openModal(CallViewPageComponent, {isVideo: this.isVideo, callName: this.callName});
        }
      }
    });
  }

  ngOnDestroy() {
    this.onUpdateUI.unsubscribe();
  }

  startVideoCall(contect: any) {
    this.isVideo = true;
    this.callName = contect.firstname + ' ' + contect.lastname;
    this.sipProvider.startCall(contect.code, {audio: true, video: true});
  }

  startCall(contect: any) {
    this.isVideo = false;
    this.callName = contect.firstname + ' ' + contect.lastname;
    this.sipProvider.startCall(contect.code, {audio: true, video: false});
  }

  async startChat(contect: any) {
    await this.dismiss();
    await this.modalCtrl.openModal(ChatPageComponent, {
      toUserId: contect.code,
      toUserName: contect.firstname + ' ' + contect.lastname,
      cssClass: 'chatModal'
    });
  }

  async dismiss() {
    await this.viewCtrl.dismiss();
  }
}
